// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".starter-template{padding:3rem 1.5rem;text-align:center}", "",{"version":3,"sources":["webpack://./app/styles/welcome.scss"],"names":[],"mappings":"AAAA,kBAAkB,mBAAmB,CAAC,iBAAiB","sourcesContent":[".starter-template{padding:3rem 1.5rem;text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
